module.exports = __webpack_public_path__ + "img/phone--mobile.cfe4ee7.webp";